import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next'; import { getPreliminaryQuestionByLanguage } from 'utils/browserUtil';
import DropDownSelector from 'components/DropDownSelector';
import './styles.scss';


const AgeQuestion = ({
    updateAnswers, age, ages, languageId
}) => {
    return (
        <div className='options-container'>
            {ages.slice(0, -1).map((ageOption, idx) => {
                return (
                    <div key={ idx } className='input-option'>
                        {ageOption.id !== 13 && <input type='radio' checked={ ageOption.id === age.id } onChange={ () => updateAnswers('age', ageOption) } />}
                        <span>{getPreliminaryQuestionByLanguage(ageOption, languageId)}</span>
                    </div>
                );
            })}
            <div className='mobile-options'>
                <DropDownSelector
                    selected={ age.value ? age : { value: null, title: i18n.t('motivator.please_select') } }
                    options={ ages.slice(0, -1).map(ageOption => ({ value: ageOption.id, title: getPreliminaryQuestionByLanguage(ageOption, languageId) })) }
                    callBack={ (option) => updateAnswers('age', option) } />
            </div>
            <span
                className={ `prefer-not-to-say ${ ages.slice(-1)[0] && age.id === ages.slice(-1)[0].id ? 'selected' : '' }` }
                onClick={ () => {
                    updateAnswers('age', ages.slice(-1)[0]);
                } }>
                {i18n.t('motivator.prefer_not_to_say')}
            </span>
        </div>
    );
};

AgeQuestion.propTypes = {
    updateAnswers: PropTypes.func,
    ages: PropTypes.array,
    age: PropTypes.object,
    languageId: PropTypes.number
};

AgeQuestion.defaultProps = {
    updateAnswers: PropTypes.func,
    ages: [],
    age: null,
    languageId: 1
};

export default AgeQuestion;
